import { Component, OnDestroy, OnInit } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {ProductService} from '../../my-products/shared/product.service';
import {Product} from '../../models/product.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  isMobile: boolean = false;
  private resizeListener: any;
  private destroy$ = new Subject<void>();

  // Marques (carousel)
  brands = [
    { name: 'GUERLAIN', logo: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_400x400px.png', link: 'https://www.laparfumerie.eu/guerlain' },
    { name: 'DIOR', logo: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_DIOR.png', link: 'https://www.laparfumerie.eu/dior' },
    { name: 'YSL', logo: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_YSL.png', link: 'https://www.laparfumerie.eu/ysl' },
    { name: 'LANCÔME', logo: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LANCOME.jpg', link: 'https://www.laparfumerie.eu/lancome' },
    { name: 'Kérastase', logo: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/logo-kerastase.jpg', link: 'https://www.laparfumerie.eu/kerastase' },
    { name: 'Clarins', logo: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_CLARINS.jpg', link: 'https://www.laparfumerie.eu/clarins' },
    { name: 'JEAN-PAUL GAULTIER', logo: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/JEAN_PAUL_GAULTIER.jpg', link: 'https://www.laparfumerie.eu/jean_paul_gaultier' },
    { name: 'Hermès', logo: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_HERMES.png', link: 'https://www.laparfumerie.eu/hermes' }
  ];
   widgetProducts: Product[];
  widgetTitle: string = 'THE BEST';


  constructor(private productService : ProductService) { }

  ngOnInit() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize.bind(this));
    this.productService.getProductsByRating(4).subscribe(products=> {
      this.widgetProducts = products
    console.log('Widget Products:', this.widgetProducts)});

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    window.removeEventListener('resize', this.checkScreenSize.bind(this));
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
  }

}
